module.exports = {"140302001":"上站街道","140302002":"下站街道","140302003":"北大街街道","140302004":"南山路街道","140302005":"义井街道","140302100":"义井镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/140302.json
// module id = 372
// module chunks = 0